import React, { useEffect, useState } from 'react';

import styled from 'styled-components';

import useDelay from 'libs/hook/useDelay';
import { NOW_DELAY_SECONDS } from 'libs/const';
import { checkImage } from 'libs/utils';

const ScamOutline = styled.div<{ isDelay?: boolean }>`
  width: 100%;
  border: 1px solid
    ${({
      isDelay,
      theme: {
        now: { status },
      },
    }) => (isDelay ? status.ok : '#798298')};
`;

const Image = styled.img`
  width: 100%;
  object-fit: cover;
  object-position: center;
`;

const ScamImage = React.memo(({ scamPath }: { scamPath?: string }) => {
  const [imageStatus, setImageStatus] = useState<boolean>();
  
  useEffect(() => {
    (async () => {
      if (scamPath) {
        const ok = await checkImage(scamPath);
        setImageStatus(ok);
      }
    })();
  }, [scamPath]);

  if (imageStatus === undefined) {
    return <Image src="/assets/default_image.png" alt="scam" />;
  }

  if (!imageStatus) {
    return <Image src="/assets/error_image.png" alt="scam" />;
  }

  return <Image src={scamPath} alt="scam" />;
});

interface ScamProps {
  scamPath?: string;
  updatedAt?: string;
}

const Scam = ({ scamPath, updatedAt }: ScamProps) => {
  const { isDelay } = useDelay({ target: updatedAt, delayTime: NOW_DELAY_SECONDS, obsId: undefined });

  return (
    <ScamOutline isDelay={isDelay}>
      <ScamImage scamPath={scamPath} />
    </ScamOutline>
  );
};

export default Scam;
